import styled from 'styled-components'

export const Main = styled.div`
  max-height: calc(100vh - 64px);
  height: calc(100vh - 64px);
  padding: 48px;

  @media screen and (max-width: 600px) {
    & {
      padding: 0;
    }
  }
`

export const CredentialsArea = styled.div`
  max-width: 600px;
  margin: auto;
`



// WEBPACK FOOTER //
// ./src/components/templates/NotAuthenticatedLayout.ts